__turbopack_export_value__({
  "navRoot": "Header-module__KHjLKa__navRoot",
  "navSticky": "Header-module__KHjLKa__navSticky",
});
